import Checkbox from './Checkbox';

export * from './Checkbox.theme';

export default Checkbox;
